import * as React from 'react';
import { Subject, timer } from 'rxjs';
import { debounce } from 'rxjs/operators';
import usePrevious from '../../../hooks/usePrevious';
import isEqual from 'react-fast-compare';
import FilterStateService from '../services/FilterStateService';

import { IApiQueryData } from '../interfaces';
import { setSearchPageServiceApiUrlSuffix, updateSearchPageData } from '../actions/searchPage';

interface IUpdateObject {
    dispatch: React.Dispatch<any>;
    viewMode: string;
    debounceTime: number;
}

function useViewModeSwitchUpdate(
    apiQueryData: IApiQueryData,
    viewMode: string,
    dispatch: React.Dispatch<any>,
    updateDebounceTime: number,
    filterStateService: FilterStateService,
    excludeQueryParamsFromState: string[] = [],
    stateAsQueryParamMap: Map<string, string> = new Map()
) {
    const updateSearchPageDataObserver = React.useRef(new Subject<IUpdateObject>());
    const previousViewMode = usePrevious(viewMode);

    React.useEffect(() => {
        const subscription = updateSearchPageDataObserver.current
            .pipe(debounce(object => timer(object.debounceTime)))
            .subscribe(object => {
                object.dispatch(setSearchPageServiceApiUrlSuffix(object.viewMode));
                object.dispatch(
                    updateSearchPageData(
                        apiQueryData,
                        filterStateService,
                        false,
                        excludeQueryParamsFromState,
                        stateAsQueryParamMap
                    )
                );
            });

        return () => {
            subscription.unsubscribe();
        }
    }, []);

    React.useEffect(() => {
        if (previousViewMode === undefined || isEqual(previousViewMode, viewMode)) {
            return;
        }

        updateSearchPageDataObserver.current.next({
            dispatch,
            viewMode,
            debounceTime: updateDebounceTime,
        });
    }, [viewMode]);
}

export default useViewModeSwitchUpdate;
